import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectCurrentPageEntities} from '@ngneat/elf-pagination';

import {suppliersServicesStore} from '@store/suppliers/services/suppliers-services.store';

export const getSuppliersServicesDataSource = createRequestDataSource({
  store: suppliersServicesStore,
  data$: () => suppliersServicesStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getSuppliersServices',
  dataKey: 'suppliersServices',
});